import { useRouter } from 'next/router'
import PageLoader from 'components/Loader/PageLoader'
import Collection from './index'

const CollectionPageRouter = () => {
  const router = useRouter()

  if (!router.isReady) {
    return <PageLoader />
  }

  return <Collection />
}

export default CollectionPageRouter
